import React, { useLayoutEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import {ReactComponent as SBBLogo} from '../../assets/svg/sbb_logo.svg'
import {ReactComponent as SBBLogoMobile} from '../../assets/svg/sbb_logo_mobile.svg'

import {
	AUTH_URLS
} from '../../utils/AppConfig'

import {
	intern_toggle_panel_left_open,
	intern_toggle_modal_origin_destination_open,
	intern_toggle_modal_color_open,
	intern_set_is_authenticated,
	intern_reset_all
} from '../../actions'

const InternHeaderPanel = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();	
	const panel_left_open = useSelector(state => state.general.intern_ui.panel_left_open);
	const modal_origin_destination_open = useSelector(state => state.general.intern_ui.modal_origin_destination_open)
	const modal_color_open = useSelector(state => state.general.intern_ui.modal_color_open)
	const override_color_bg = useSelector(state => state.general.intern_config.override_color_bg)
			
	const toggle_nav_clicked = (e) => {
		e.preventDefault();
		const new_panel_left_open = panel_left_open ? false : true;
		dispatch(intern_toggle_panel_left_open(new_panel_left_open))
	}
	
	const toggle_origin_destination_clicked = (e) => {
		e.preventDefault()
		const new_modal_origin_destination_open = modal_origin_destination_open ? false : true
		dispatch(intern_toggle_modal_origin_destination_open(new_modal_origin_destination_open))
	}
	
	const toggle_modal_color_open_clicked = (e) => {
		e.preventDefault()
		const new_modal_color_open = modal_color_open ? false : true
		dispatch(intern_toggle_modal_color_open(new_modal_color_open))
	}
	
	const reset_clicked = (e) => {
		e.preventDefault()
		dispatch(intern_reset_all())
	}
	
	const logout_clicked = async (e) => {
		e.preventDefault();
		try {
			const response_login = await axios.post(AUTH_URLS.LOGOUT, {});
				
            const {
				is_authenticated,
			} = response_login.data;
            
            if(!is_authenticated) {
				dispatch(intern_set_is_authenticated(is_authenticated))
			}
            
        } catch (error) {
            const message = error.response?.data?.message || t('Abmeldung fehlgeschlagen');
            console.error('Problem in logout: ', message)
        }
	}
	
	const btn_modal_origin_destination_cls = modal_origin_destination_open ? 'button-intern mode-active' : 'button-intern'
	const btn_modal_color_cls = modal_color_open ? 'button-intern mode-active' : 'button-intern'

	const override_color_value = override_color_bg === null? 'unset': override_color_bg;
	const override_color_cls = override_color_bg === null? 'color-0': '';

	return (
		<header className="main-header">
			<button className="toggle-nav" onClick={toggle_nav_clicked} tabIndex="1">
				<span className="visuallyhidden">{t('Hauptnavigation öffnen / schliessen')}</span>
				<div className="toggle-nav-icon">
					<div className="bar bar1"></div>
					<div className="bar bar2"></div>
					<div className="bar bar3"></div>
				</div>
			</button>
            <div className="header-title intern-header-title">{t('iLNP FV intern')} - {t('Auswahl')}</div>
			<div className="intern-header-nav tablet-plus-only">
					<button type="button" className={btn_modal_origin_destination_cls} onClick={toggle_origin_destination_clicked}>
						<div className={'button-bg'}></div>
						<div className={'button-text'}>{t('Start / Ziel')}</div>
					</button>
					<button type="button" className={`${btn_modal_color_cls} color-button`} onClick={toggle_modal_color_open_clicked}>
						<div className={'button-bg'}></div>
						<div className={'button-text'}>{t('Farbe')}</div>
						<div className={'selected-color'}>
							<div className={`color-circle ${override_color_cls}`} style={{backgroundColor: override_color_value}}></div>
						</div>
					</button>
					<button type="button" className={'button-intern'} onClick={reset_clicked}>
						<div className={'button-bg'}></div>
						<div className={'button-text'}>{t('Reset')}</div>
					</button>
					<button type="button" className={'button-intern logout-button'} onClick={logout_clicked}>
						<div className={'button-bg'}></div>
						<div className={'button-text'}>{t('Abmelden')}</div>
					</button>
			</div>
			<div className="sbb-logo logo-mobile mobile-only">
				<SBBLogoMobile />
			</div>
			<div className="sbb-logo logo-tablet-plus tablet-plus-only">
				<SBBLogo />
			</div>
		</header>
	)
}

export default InternHeaderPanel